const isAndroidSamsung = () => navigator.userAgent.match(/Android|SAMSUNG/g);

export default isAndroidSamsung;
